export const version = "wallet/5.8.0";
//# sourceMappingURL=_version.js.map